// olo event
document.querySelectorAll(`a[href="https://saltandstraw.olo.com/"]`).forEach(function(element) {
  element.addEventListener("click", async function(e) {
    e.preventDefault();
    
    // Track
    await klaviyo.push(["track", "Clicked Local Options"]);

    window.location.href = this.href;
    
  })
});

// upsell
const upsells = JSON.parse(document.querySelector("#upsellJSON").textContent);

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

// mutation observer to add upsell to cart
const observer = new MutationObserver(function () {
    // check if: cart is open, upsell doesn't exist, ajaxcart exists, there is no scooper
    if (
        document.querySelector("body.js-drawer-open") &&
        document.querySelector("#cartUpsell") == null &&
        document.querySelector(".ajaxcart__inner")
    ) {

        // determine correct product
        if (
            isHandleInCart("best-sellers-pint-pack") &&
            !isHandleInCart("addon-honey-lavender")
        ) {
            addUpsell("addon-honey-lavender");
        } else if (
            isHandleInCart("pick-your-pints") && document.querySelectorAll(".sub_items .sub_item").length === 5 &&
            !isHandleInCart("sea-salt-with-caramel-ribbons") &&
            !isHandleInCart("addon-sea-salt")
        ) {
            addUpsell("addon-sea-salt");
        } else if (
            isHandleInCart("pick-your-pints") && document.querySelectorAll(".sub_items .sub_item").length === 5 &&
            !isHandleInCart("addon-sea-salt") &&
            !isHandleInCart("addon-freckled-mint")
        ) {
            addUpsell("addon-freckled-mint");
        } else if (
            isHandleInCart("pints-of-the-month-pack") &&
            !isHandleInCart("addon-sea-salt")
        ) {
            addUpsell("addon-sea-salt");
        }

    }

});

// chec for only upsells
function checkForOnlyUpsells() {
    // check if there is only addons in the cart
    if (
        document.querySelector("body.js-drawer-open") &&
        document.querySelectorAll(`.ajaxcart__product:not(.is-removed) .ajaxcart__product-name`).length == 1 &&
        document.querySelectorAll(`.ajaxcart__product:not(.is-removed) .ajaxcart__product-name[href*="addon"]`).length == 1
    ) {
        document.querySelector(`.ajaxcart__product:not(.is-removed) .ajaxcart__qty--minus`).click();
    }
}

// check if handle is in cart
function isHandleInCart(handle) {
    return cart.items.filter(item => item.handle == handle).length > 0;
}

// add upsell based on handle
function addUpsell(handle) {
    // find product
    let upsell = upsells.filter(item => item.handle == handle)[0];

    // append html
    document.querySelector(".ajaxcart__inner").insertAdjacentHTML("beforeend", `
            <div id="cartUpsell">
                <div id="cartUpsellHeader">Craving more? Save on your next pint!</div>
                <img id="cartUpsellImage" src="${upsell.featured_image}&width=200">
                <div id="cartUpsellTitle">${upsell.title.replace(" Add-on", "")}</div>
                <div id="cartUpsellForm">
                    <div id="cartUpsellFormPrice">Only $${(upsell.price / 100).toFixed(2)}</div>
                    <button id="cartUpsellFormATC">ADD</button>
                </div>
            </div>
        `);

    // event listener
    document.querySelector("#cartUpsellFormATC").addEventListener("click", async function (e) {
        e.preventDefault();
        this.classList.add("loading");
        await addProduct({quantity: 1, id: upsell.variants[0].id});
        ajaxCart.load();
        document.querySelector("#cartUpsell").remove();
    })
}

// observer attributes for body element
observer.observe(
    document.querySelector("body"),
    {
        attributes: true,
        attributeFilter: ["class"]
    }
);